module.exports = __webpack_public_path__ + "images/chatmsg_18a5e60.png";